import { tw } from "@careinfo/tailwind";
import { Popover, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import NewChatIcon from "../../../Icons/NewChatIcon";
import useGetHook from "../../../customHooks/useGetHook";
import APIS from "../../../constant/Endpoint";
import UserIcon from "../../../Icons/UserIcon";
import Group from "../../../Icons/GropIcon";
import Button from "../../Button";
import LeftIcon from "../../../Icons/LeftIcon";
import { ChatSekeleton } from ".";
import TextField from "../../TextInput";
import { useForm } from "react-hook-form";
import { getKey } from "../../../helpers/sessionKey";

const NewChat = ({
  handleCreateGroup,
  handleCreateSupportGroup,
  is_groupTypePrivate,
  setIsGroupTypePrivate,
  selectedUserIds,
  setSelectedUserIds,
}) => {
  const isStaff = getKey("is_staff");
  const [userList, setUserList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const { data: userData, isLoading } = useGetHook({
    queryKey: [`users-${searchTerm}`],
    params: {
      limit: 20,
      offset: 0,
      is_active: true,
      search: searchTerm,
    },
    url: APIS.USER,
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});

  useEffect(() => {
    if (Array.isArray(userData?.results) && userData?.results?.length > 0) {
      setUserList(userData?.results ?? []);
    }
  }, [userData]);

  return (
    <div>
      <Popover className={tw`relative`}>
        {({ open, close }) => (
          <>
            <Popover.Button
              className={tw`group inline-flex items-center  focus:outline-none `}
            >
              <NewChatIcon />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel
                className={tw`absolute z-10 mt-3 max-w-sm w-[350px] px-4 -mx-[300px]`}
              >
                <div
                  className={tw`bg-gray-200 p-2 rounded-md h-[70vh] flex flex-col`}
                >
                  {!is_groupTypePrivate ? (
                    <div className={tw`flex items-center gap-x-2`}>
                      <button
                        type="button"
                        className={tw`focus:outline-none`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsGroupTypePrivate(!is_groupTypePrivate);
                        }}
                      >
                        <LeftIcon />
                      </button>
                      <p className={tw`text-lg font-semibold`}>New Group</p>
                    </div>
                  ) : (
                    <p className={tw`text-lg font-semibold`}>New Chat</p>
                  )}
                  <input
                    type="text"
                    className={tw`bg-white p-2 my-2 focus:outline-none w-full`}
                    placeholder="Search name..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                    }}
                  />

                  {selectedUserIds?.length > 1 ? (
                    <form
                      onSubmit={handleSubmit((data) => {
                        handleCreateGroup(reset, selectedUserIds, false, data);
                        close();
                      })}
                    >
                      <TextField
                        label={"Group Name"}
                        placeholder={"Enter group name"}
                        register={register("name", {
                          required: "Name is required",
                        })}
                        errors={errors.name}
                      />
                      <div
                        className={tw`grid grid-cols-2 gap-x-2 items-center mb-1`}
                      >
                        <Button label={"Create"} />
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsGroupTypePrivate(!is_groupTypePrivate);
                            setSelectedUserIds([]);
                          }}
                          className={tw`bg-gray-300 w-full py-2 rounded  focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1 `}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  ) : null}
                  <div
                    className={tw`overflow-y-auto flex-1 `}
                    style={{
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    <style>{`
                       div::-webkit-scrollbar {
                       display: none;
                       }
                    `}</style>
                    {is_groupTypePrivate && (
                      <>
                        {isStaff === "false" ? (
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCreateSupportGroup();
                              close();
                            }}
                            className={tw`border-b mb-1 p-2 w-full bg-white hover:bg-gray-100 flex text-left items-center gap-x-2 focus:outline-none`}
                          >
                            <Group width={40} height={40} />
                            <p className={tw`font-semibold`}>Support</p>
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsGroupTypePrivate(!is_groupTypePrivate);
                            }}
                            className={tw`border-b mb-1 p-2 w-full bg-white hover:bg-gray-100 flex text-left items-center gap-x-2 focus:outline-none`}
                          >
                            <Group width={40} height={40} />
                            <p className={tw`font-semibold`}>New Group</p>
                          </button>
                        )}
                      </>
                    )}
                    {isLoading
                      ? Array.from({ length: 10 }, () => (
                          <ChatSekeleton key={crypto.randomUUID()} />
                        ))
                      : is_groupTypePrivate
                      ? userList?.map((item) => {
                          return (
                            <User
                              key={item?.id}
                              data={item}
                              reset={reset}
                              handleCreateGroup={handleCreateGroup}
                              close={close}
                            />
                          );
                        })
                      : userList?.map((item) => {
                          return (
                            <UserSelect
                              key={item?.id}
                              data={item}
                              selectedUserIds={selectedUserIds}
                              setSelectedUserIds={setSelectedUserIds}
                            />
                          );
                        })}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
};

export default NewChat;

export function User({ data, reset, handleCreateGroup, close }) {
  const is_private = true;
  const users = [data?.id];
  return (
    <button
      onClick={() => {
        handleCreateGroup(reset, users, is_private);
        close();
      }}
      className={tw`border-b p-2 w-full bg-white hover:bg-gray-100 flex text-left items-center gap-x-2 focus:outline-none`}
    >
      <UserIcon width={40} height={40} />
      <p className={tw`font-semibold`}>{data?.name}</p>
    </button>
  );
}

export function UserSelect({ data, selectedUserIds, setSelectedUserIds }) {
  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedUserIds((prev) => [...prev, value]);
    } else {
      setSelectedUserIds((prev) => prev.filter((id) => id !== value));
    }
  };
  return (
    <button
      className={tw`border-b p-2 w-full bg-white hover:bg-gray-100 flex justify-between items-center focus:outline-none`}
    >
      <div className={tw`flex items-center gap-x-2`}>
        <UserIcon width={40} height={40} />
        <p className={tw`font-semibold`}>{data?.name}</p>
      </div>
      <input
        type="checkbox"
        value={data?.id}
        checked={selectedUserIds.includes(String(data?.id))}
        onChange={handleCheckboxChange}
        onClick={(e) => e.stopPropagation()}
      />
    </button>
  );
}
